import { useState } from 'react'
import ModalHistoryOrder from '@/entities/profile-page/historyOrders/ModalHistoryOrder/index.js'

export const CardOrder = ({ orderData }) => {
    const [showModalHistoryOrder, setShowModalHistoryOrder] = useState(false)

    const orderDate = orderData.date_added.split(' ').reverse().join(' ')
    const addressDelivery =
        orderData.payment_zone + ', ' + orderData.shipping_address_1
    const totalPrice = Math.round(orderData.total).toLocaleString('RU-ru')

    return (
        <div className={'CardOrder'}>
            <div className={'header'}>
                <h2>Заказ №{orderData.order_id}</h2>
                <span>{orderData.status_name}</span>
            </div>
            <div className={'main'}>
                <div className={'row-item'}>
                    <h3>Дата заказа:</h3>
                    <p>{orderDate}</p>
                </div>
                <div className={'row-item'}>
                    <h3>Адрес доставки:</h3>
                    <p>{addressDelivery}</p>
                </div>
                <div className={'row-item'}>
                    <h3>Сумма заказа:</h3>
                    <p>{totalPrice} ₽</p>
                </div>
            </div>
            <div
                className={'action'}
                onClick={() => setShowModalHistoryOrder(true)}
            >
                <span>Товаров: {orderData.products_count}</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="10"
                    viewBox="0 0 6 10"
                    fill="none"
                >
                    <path
                        d="M1 0.854492L5 4.85449L1 8.85449"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>
            <ModalHistoryOrder
                show={showModalHistoryOrder}
                onHide={() => setShowModalHistoryOrder(false)}
                orderId={orderData.order_id}
                statusOrder={orderData.status_name}
            />
        </div>
    )
}
